import React, { useEffect, useState } from 'react';
import { getImage } from './utils';

/**
 * Imagen de producto con fallback a ícono cuando no hay URL o la carga falla.
 * Acepta className, style, onClick, title y alt como un <img> normal.
 * En el fallback se omite onClick (no hay imagen que ampliar).
 */
export default function ProductImage({ url, alt = '', className = '', ...rest }) {
    const [failed, setFailed] = useState(false);
    useEffect(() => { setFailed(false); }, [url]);

    if (!url || failed) {
        // eslint-disable-next-line no-unused-vars
        const { onClick, onError, ...spanProps } = rest;
        return (
            <span
                {...spanProps}
                className={`${className.replace(/\bpointer\b/, '').trim()} product-img-empty`}
                role="img"
                aria-label={alt || 'Sin imagen'}
            >
                <i className="fa fa-image" aria-hidden="true" />
            </span>
        );
    }
    return (
        <img
            {...rest}
            src={getImage(url)}
            alt={alt}
            className={className}
            onError={() => setFailed(true)}
        />
    );
}
